import { TableCell } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { SearchContext } from "../../../context/searchText";
import CopyTxtIconBtn from "../../../components/CopyTxtIconBtn";

type props = {
    value: string, 
    to: string
}

const TxHashCell = ({value, to = "#"}: props) => {
    const {searchTerm} = useContext(SearchContext);
    const text = value.replaceAll(searchTerm, "##@##").split( "##@##").reduce(
        ((acc, txt, i) => {
            if(i){
                acc.push(<mark key={txt+"marked"+i}>{searchTerm}</mark>);
            }
            acc.push(txt);
            
            return acc;
        })
    ,[] as (JSX.Element | string)[]);

    return (
        <TableCell 
            align="left"
            sx={{
                maxWidth: {xs: "50px", md: "300px"},
                overflow: {xs: "hidden"},
                textOverflow: {xs: "ellipsis"},
                whiteSpace: {xs: "nowrap"},
            }}
        >
            <CopyTxtIconBtn value={value}/>
            <Link style={{color: "white"}} to={to}>{text.map((txt) => txt)}</Link>
            
        </TableCell>
    );
}

export default TxHashCell;